import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Shared_ContactPersonPermissionKinds } from "src/backend/openapi/v1";
import { RootState } from "src/store";

export const usePermissionCheck = (permissions: Shared_ContactPersonPermissionKinds[]): boolean[] => {
  const contactPersonDetails = useSelector((state: RootState) => state.generalReducer.applicationReducer.contactPersonDetails);

  const data = useMemo(() => {
    if (contactPersonDetails.loading === "has-loaded") {
      return permissions.map(permission => !!contactPersonDetails.data.permissions.includes(permission));
    }
    return [];
  }, [contactPersonDetails]);

  return data;
};
